// extracted by mini-css-extract-plugin
export default {"cardWrapper":"Card_cardWrapper__i4JLN","modalButtonsWrapper":"Card_modalButtonsWrapper__M9MBH"};